import React from 'react'
import styles from './cover.m.scss'

export const Cover = () => {
  return (
    <div className={styles.cover}>
      <div className={styles.videoContainer}>
        <video
          // onLoadedData={e => {
          //   console.log(
          //     (e.target.currentTime = e.target.duration * Math.random())
          //   )
          // }}
          className={styles.video}
          autoPlay
          loop
          playsInline
          muted
        >
          <source src={require('./intro.mp4')} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className={styles.videoContainer}>
        <video
          // onLoadedData={e => {
          //   console.log(
          //     (e.target.currentTime = e.target.duration * Math.random())
          //   )
          // }}
          className={styles.video}
          autoPlay
          loop
          playsInline
          muted
        >
          <source src={require('./intro.mp4')} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className={styles.videoContainer}>
        <video
          // onLoadedData={e => {
          //   console.log(
          //     (e.target.currentTime = e.target.duration * Math.random())
          //   )
          // }}
          className={styles.video}
          autoPlay
          loop
          playsInline
          muted
        >
          <source src={require('./intro.mp4')} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  )
}
